// Imports
import { urlSuscripcionExternaTarjetaP2P } from "../../constants/urls";
import {FetchPost} from './api';
import { createAction } from "redux-actions";


// ------------------------- Inician Acciones -------------------------

export const setSuscripcionTarjetaP2PLoading = createAction("SET_SUSCRIPCION_TARJETA_P2P_LOADING");
export const setSuscripcionTarjetaP2PHasErrror = createAction("SET_SUSCRIPCION_TARJETA_P2P_HAS_ERROR");
export const setSuscripcionTarjetaP2PResponse = createAction("SET_SUSCRIPCION_TARJETA_P2P_RESPONSE");

// ------------------------- Terminan Acciones -------------------------




//------------------------- Inician Funciones que utilizan acciones -------------------------

export const suscripcionExternaTarjetaP2P = (param) => async (dispatch) => {
  let url = urlSuscripcionExternaTarjetaP2P;
  dispatch(setSuscripcionTarjetaP2PLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => response.json())
    .then((data) => {
      const transaccion = data.transaccion;
      if (transaccion) {
        dispatch(setSuscripcionTarjetaP2PResponse(data));
      } else {
        dispatch(setSuscripcionTarjetaP2PHasErrror())
      }
    })
    .catch(() => {
      dispatch(setSuscripcionTarjetaP2PHasErrror())
    });
};

//------------------------- Terminan Funciones que utilizan acciones -------------------------